import { render } from "./PromotionsPage.vue?vue&type=template&id=132f5dd3&scoped=true"
import script from "./PromotionsPage.vue?vue&type=script&lang=js"
export * from "./PromotionsPage.vue?vue&type=script&lang=js"

import "./PromotionsPage.vue?vue&type=style&index=0&id=132f5dd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132f5dd3"]])

export default __exports__